var map = {
	"./en_us.png": "d5d1",
	"./es_spa.png": "2562",
	"./ja_ja.png": "6a7b",
	"./ko_ko.png": "a1ce",
	"./ms_my.png": "b3e0",
	"./vn_vn.png": "e7cd",
	"./zh_cn.png": "bc77"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79a4e";